import angular from "angular";
import cart from "emun.cart/cart";
import cartCreditCard from "emun.cart/cart-creditcard";
import cartForms from "emun.cart/cart-forms";
import cartItemEntry from "emun.cart/cart-item-entry";
import cartItemInput from "emun.cart/cart-item-input";
import cartManageShipdates from "emun.cart/cart-manage-shipdates";
import cartPicker from "emun.cart/cart-picker.directive";
import CartPicker from "emun.cart/cart-picker.factory";
import cartScan from "emun.cart/cart-scan";
import createCartComponent from "emun.cart/cart.create-component";
import cartService from "emun.cart/cart.service";
import cartCreditCardNmi from "emun.cart/nmi/cart-creditcard-nmi";
import cartCreditCardAptean from "emun.cart/aptean/cart-creditcard-aptean";
import cartCreditCardPayfabric from "emun.cart/payfabric/cart-creditcard-payfabric";
import cartCreditCardSnappay from "emun.cart/snappay/cart-creditcard-snappay";
import cartCreditCardUsaepay from "emun.cart/usaepay/cart-creditcard-usaepay";
import cartCreditCardVersapay from "emun.cart/versapay/cart-creditcard-versapay";
import shoppingConfig from "emun.shopping/shopping.config";
import multiCart from "emun.cart/multi-cart/multi-cart";
import "ng";
import "ng-file-upload";
import "servicestack/_servicestack.app";
import "webforms/app";
import "webmodals/_webmodals.app";
import "webutils/app";
//import cartCategoryRestrictions from "emun.cart/cart-category-restrictions";
import cartAutoPrint from "emun.cart/cart-auto-print";
import cartItemQuickView from "emun.cart/cart-item-quick-view";
import cartItemQuickViewActions from "emun.cart/cart-item-quick-view-actions";
import cartItemQuickViewImage from "emun.cart/cart-item-quick-view-image";
import cartItemQuickViewInfo from "emun.cart/cart-item-quick-view-info";
import cartItemQuickViewOptions from "emun.cart/cart-item-quick-view-options";
import cartItemQuickViewSizeoptions from "emun.cart/cart-item-quick-view-sizeoptions";
import cartItemQuickViewColoroptions from "emun.cart/cart-item-quick-view-coloroptions";
import cartItemQuickViewPersonalize from "emun.cart/cart-item-quick-view-personalize";
import cartPricelistDropdownMenu from "emun.cart/cart-pricelist-dropdown-menu";
import cartShipLocation from "emun.cart/cart-ship-location";
import checkout from "emun.cart/checkout";
import continueShopping from "emun.cart/continue-shopping";
import cartFileImport from "emun.cart/import/cart-file-import";
import OrderConfirmation from "emun.cart/order-confirmation";
import contactPromptDirective from "emun.customer/contact-prompt-directive";

// import contactPrompt from "emun.customer/contact-prompt";
import {
  ShippingLocationEditorDirectiveFactory,
  ShippingLocationEditorFactory,
} from "emun.cart/shipping-location-editor";
import {
  ShippingLocationPickerDirectiveFactory,
  ShippingLocationPickerFactory,
} from "emun.cart/shipping-location-picker";
import {
  ShippingLocationPromptDirectiveFactory,
  ShippingLocationPromptFactory,
} from "emun.cart/shipping-location-prompt";

//const deps = ['webutils', 'webforms', 'webmodals', 'angular-growl', 'infinite-scroll', 'servicestack', 'ngFileUpload', 'moment-picker', 'paypal-button'];
const deps = [
  "webutils",
  "webforms",
  "webmodals",
  "angular-growl",
  "infinite-scroll",
  "servicestack",
  "ngFileUpload",
  "moment-picker",
];

function Run($rootScope, $cart) {
  $rootScope.$cart = $cart;
}

export const app = angular
  .module("emun.cart", deps)
  .factory("$cart", cartService) //factory
  .component("cart", cart)
  .component("cartItemEntry", cartItemEntry)
  .component("cartItemInput", cartItemInput)
  .component("cartScan", cartScan)
  .component("cartFileImport", cartFileImport)
  .component(
    "cartDropdownMenu",
    createCartComponent(require("emun.cart/cart-dropdown-menu.htm"))
  )
  .component(
    "cartPointsSummary",
    createCartComponent(require("emun.cart/cart-points-summary.htm"))
  )
  .component(
    "cartContainerSummary",
    createCartComponent(require("emun.cart/cart-container-summary.htm"))
  )
  .component(
    "wishlistDropdown",
    createCartComponent(require("emun.cart/wishlist-dropdown.htm"))
  )
  .component("checkout", checkout)
  .component(
    "cartCategoryRestrictions",
    createCartComponent(require("emun.cart/cart-category-restrictions.htm"))
  )
  .component(
    "cartVendorMinimums",
    createCartComponent(require("emun.cart/cart-vendor-minimums.htm"))
  )
  .component(
    "cartShipDateMinimums",
    createCartComponent(require("emun.cart/cart-shipdate-minimums.htm"))
  )
  .component(
    "cartVolumeMinimums",
    createCartComponent(require("emun.cart/cart-volume-minimums.htm"))
  )
  .component(
    "cartList",
    createCartComponent(require("emun.cart/cart-list.htm"), {
      cart: "<?",
      hideHeader: "<?",
      useQuickView: "<?",
    })
  )
  .component(
    "cartListStatus",
    createCartComponent(require("emun.cart/cart-list-status.htm"), {
      status: "@",
    })
  )
  .component(
    "cartListHeader",
    createCartComponent(require("emun.cart/cart-list-header.htm"), {
      useQuickView: "<?",
    })
  )
  .component(
    "cartListItemImage",
    createCartComponent(require("emun.cart/cart-list-item-image.htm"), {
      cartItem: "<",
    })
  )
  .component(
    "cartListItemImageActions",
    createCartComponent(require("emun.cart/cart-list-item-image-actions.htm"), {
      cartItem: "<",
    })
  )
  .component(
    "cartListItemAttributes",
    createCartComponent(require("emun.cart/cart-list-item-attributes.htm"), {
      cartItem: "<",
    })
  )
  .component(
    "cartListItemDetails",
    createCartComponent(require("emun.cart/cart-list-item-details.htm"), {
      cartItem: "<",
    })
  )
  .component(
    "cartListItemActions",
    createCartComponent(require("emun.cart/cart-list-item-actions.htm"), {
      cartItem: "<",
    })
  )
  .component(
    "cartItemAdditionalInfoFieldset",
    createCartComponent(
      require("emun.cart/cart-item-additional-info-fieldset.htm"),
      {
        cartItem: "<",
        allowPriceOverride: "@",
        shipdates: "<"
      }
    )
  )
  .component(
    "cartSummary",
    createCartComponent(require("emun.cart/cart-summary.htm"))
  )
  .component(
    "cartPromos",
    createCartComponent(require("emun.cart/cart-promos.htm"))
  )
  .component("cartPricelistDropdownMenu", cartPricelistDropdownMenu)
  .component("cartShipLocation", cartShipLocation)
  .component("cartAutoPrint", cartAutoPrint)
  .component(
    "cartInlineShipaddress",
    createCartComponent(require("emun.cart/cart-inline-shipaddress.htm"))
  )
  .component("cartCreditcard", cartCreditCard)
  .component("cartCreditcardPayfabric", cartCreditCardPayfabric)
  .component("cartCreditcardSnappay", cartCreditCardSnappay)
  .component("cartCreditcardAptean", cartCreditCardAptean)
  .component("cartCreditcardVersapay", cartCreditCardVersapay)
  .component("cartCreditcardNmi", cartCreditCardNmi)
  .component("cartCreditcardUsaepay", cartCreditCardUsaepay)
  .component("cartForms", cartForms)
  .component("cartManageShipdates", cartManageShipdates)
  .component(
    "cartShipRate",
    createCartComponent(require("emun.cart/cart-ship-rate.htm"))
  )
  .component(
    "discountCodes",
    createCartComponent(require("emun.cart/discount-codes.htm"))
  )
  .component("orderConfirmation", OrderConfirmation)
  .component("continueShopping", continueShopping)
  .component(
    "emailSubscribe",
    createCartComponent(require("emun.cart/email-subscribe.htm"))
  )
  .directive("cartItemQuickView", cartItemQuickView)
  .directive("cartItemQuickViewActions", cartItemQuickViewActions)
  .directive("cartItemQuickViewOptions", cartItemQuickViewOptions)
  .directive("cartItemQuickViewSizeoptions", cartItemQuickViewSizeoptions)
  .directive("cartItemQuickViewColoroptions", cartItemQuickViewColoroptions)
  .directive("cartItemQuickViewPersonalize", cartItemQuickViewPersonalize)
  .directive("cartItemQuickViewInfo", cartItemQuickViewInfo)
  .directive("cartItemQuickViewImage", cartItemQuickViewImage)
  .directive("contactPrompt", contactPromptDirective)
  .factory("ShippingLocationPrompt", ShippingLocationPromptFactory)
  .directive("shippingLocationPrompt", ShippingLocationPromptDirectiveFactory)
  .factory("ShippingLocationEditor", ShippingLocationEditorFactory)
  .directive("shippingLocationEditor", ShippingLocationEditorDirectiveFactory)
  .factory("ShippingLocationPicker", ShippingLocationPickerFactory)
  .directive("shippingLocationPicker", ShippingLocationPickerDirectiveFactory)
  .factory("CartPicker", CartPicker)
  .directive("cartPicker", cartPicker)
  .run(Run);

if (shoppingConfig.multiCart) {
  app.component("multiCart", multiCart);
}

export default app.name;
